module.exports = __webpack_public_path__ + "media/images/transparent-622a604bd8b273c9fcf5fab25dd6ef43.png";